import React, { Component } from 'react';
import { Form, Input, Button, Icon, Spin } from 'antd';

export default class ResetForm extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.submitHandler(values.email);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { loading } = this.props;

        return (
            <Form onSubmit={this.handleSubmit} className="login-form" style={styles.form}>
                <Form.Item>
                    {getFieldDecorator('email', {
                        rules: [
                            { required: true, message: 'Email saknas!' }
                        ],
                    })(
                        <Input prefix={<Icon type="mail" style={styles.input} />} placeholder="E-post" />
                    )}
                </Form.Item>
                <Form.Item>
                    <Spin spinning={loading}>
                        <Button type="primary" block htmlType="submit" className="login-form-button">
                            Återställ
                        </Button>
                    </Spin>
                </Form.Item>
            </Form>
        );
    };
}

const styles = {
    input: { color: 'rgba(0,0,0,.25)' }
};


// WEBPACK FOOTER //
// ./src/screens/auth/components/reset/Form.js